// extracted by mini-css-extract-plugin
export default {"wrap":"Loader_wrap__FKFye","loader":"Loader_loader__DwtSp","rotation":"Loader_rotation__zW3DX"};